module.exports = __webpack_public_path__ + "static/media/paymentPage.e90c76fc.png";